import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslationService } from '@sdbn/common';

export class ConfirmDialogData {
  titleKey: string;
  messageKey: string;
  messageParams?: any[];
  confirmBtnKey?: string = null;
  confirm: () => void;
  cancel?: () => void;
}

@Component({
    selector: 'app-confirm-dialog-old',
    templateUrl: 'confirm.dialog.component.html',
    styleUrls: ['confirm.dialog.component.scss'],
    standalone: false
})
// TODO ausbauen dialog.confirm statt dessen verwenden
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
    public translationService: TranslationService) { }

  confirm() {
    this.dialogRef.close(true);
    this.data.confirm();
  }

  cancel() {
    this.dialogRef.close();
    if (this.data.cancel) {
      this.data.cancel();
    }
  }

  public getMessageArgs() {
    const args: any[] = [];

    args.push(this.data.messageKey);
    args.push(this.translationService.language);

    if (this.data.messageParams != null) {
      for (const p of this.data.messageParams) {
        args.push(p);
      }
    }

    return args;
  }
}
